import React, { useState, useEffect } from 'react'
import { defaultPage } from '../../Common/Constant';
import { userList } from '../../api/users';
// import { getDownloadFile } from "../../ApiService";
import Footer from '../Layout/Footer';
import Header from '../Layout/Header';
import Sidebar from '../Layout/Sidebar';
import Pagination from '../Layout/Pagination';
// import Swal from 'sweetalert2';

function DeletedUser() {
    useEffect(() => {
        document.title = "Deleted Panelist - Brand Synergix"
    },);
    const [searchKeyword, setSearchKeyword] = useState();
    const [listType, setListType] = useState("deleted");
    const [lists, setLists] = useState();
    const [pageInfo, setPageInfo] = useState(defaultPage)
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();

    useEffect(() => {
        getList()
    }, [listType]);

    const changePage = (pageInfo) => {
        setPageInfo(pageInfo)
    }

    const getList = async() =>{
        if(listType){
            setSearchKeyword(document.getElementById('searchKeyWord').value);            
            let payloadData = {
                listType: listType,
                q: searchKeyword ? searchKeyword : "",
                page: pageInfo.current_page ? pageInfo.current_page : 0, 
                recPerPage: pageInfo.perPage ? pageInfo.perPage : 50,
                from: startDate ? Math.floor(new Date(startDate+' 00:00:00').getTime()/1000) : "",
                to: endDate ? Math.floor(new Date(endDate+' 23:59:59').getTime()/1000) : ""
            }
            let res = await userList({payload: payloadData});
            if(res.status === 1){
                setLists(res.payload);
                setPageInfo(res.paginationInfo);
            } else{
                setLists([])
            }
        }
    }

    return (
        <div>
            <Sidebar />
            <Header />
            <div id="layout-wrapper">
                <div className="main-content">
                    <div className="page-content">
                        <div className="container-fluid">
                            {/* <!-- start page title --> */}
                            <div className="row">
                                <div className="col-12 col-lg-12 col-xl-12 col-md-12">
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item">Panelist</li>
                                                <li className="breadcrumb-item active">Deleted</li>
                                            </ol>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            {/* <!-- end page title --> */}

                            <div className='d-flex justify-content-end align-items-center gap-3'>                                
                                <div className="mb-3 row mx-2">
                                    <label htmlFor="Projectdescription" className="form-label mb-0">Search <span className="required_field">*</span></label>
                                    <input type="text" onKeyDown={(e)=>setSearchKeyword(e.target.value)} className="form-control" placeholder='Search by name, email, phone . . .' id="searchKeyWord" />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="startDate" className="form-label mb-0">From <span className="required_field">*</span></label>
                                    <input type="date" onChange={(e)=>setStartDate(e.target.value)} className="form-control" id="startDate" />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="endDate" className="form-label mb-0">To <span className="required_field">*</span></label>
                                    <input type="date" onChange={(e)=>setEndDate(e.target.value)} className="form-control" id="endDate" />
                                </div> 
                                <div className="mb-3 d-flex align-items-center">
                                    <button className="btn btn-primary mt-3" onClick={()=>getList()}>
                                        <i className="mdi mdi-magnify"></i> Go
                                    </button>
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-xl-12 col-lg-12">
                                    <div className="card">
                                        {/* <!-- end card header --> */}
                                        <div className="card-body">
                                            <table className="table table-striped table-hover table_client">
                                                <thead>
                                                    <tr className="bg-orange" style={{ color: "white" }}>
                                                        <th scope="col">Sr. no.</th>
                                                        <th scope="col" style={{textAlign:"left"}}>Name</th>
                                                        <th scope="col" style={{textAlign:"left"}}>Phone</th>
                                                        <th scope="col" style={{textAlign:"left"}}>Email</th>
                                                        <th scope="col" style={{textAlign:"left"}}>Deleted On</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="table-body">
                                                    {lists ? (<>
                                                        {lists?.length > 0 ? (<>
                                                            {lists?.map((row, index) => {
                                                                return(<>
                                                                <tr key={index+1} id={row?.ID}>
                                                                    <td>{(pageInfo.current_page-1)*pageInfo.perPage + ++index}</td>
                                                                    <td style={{textAlign:"left"}}>
                                                                        {row?.firstName !== null ? row?.firstName : "-"} {row?.lastName !== null ? row?.lastName : ""}
                                                                    </td>
                                                                    <td style={{textAlign:"left"}}>{row?.phone && row?.phone !== null && row?.phone !== "" ? row?.phone : "-"}</td>
                                                                    <td style={{textAlign:"left"}}>{row?.email}</td>
                                                                    <td style={{textAlign:"left"}}>{row?.accountDeletedOn !== null ? row?.accountDeletedOn : "-"}</td>
                                                                </tr>
                                                                </>)
                                                            })}
                                                        </>) : (<>
                                                            <tr>
                                                                <td colSpan={5}>No data found</td>
                                                            </tr>
                                                        </>)}
                                                    </>) : 
                                                    (<></>)}                                                  
                                                </tbody>                                                
                                            </table>
                                            <Pagination pagination={pageInfo} changePage={changePage} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <!-- end row--> */}
                            {/* <!-- end row --> */}
                        </div>
                        {/* <!-- container-fluid --> */}
                    </div>
                    {/* <!-- End Page-content --> */}
                </div>
            </div>
            <Footer /> 
        </div>
    )
}

export default DeletedUser;